//import
// initial state
var state = {
  // types of msgToUser: "success", info", "warning" and "error"
  msgToUser: [{
    msg: "Hi, CES GSTS user!",
    type: "info"
  }],
  // msg to inform this is the end of drilling, no more choices available
  extraLogs: []
}; // getters

var getters = {
  extraLogsOutput: function extraLogsOutput(state) {
    // todo: consider merge extraLogs & extraLogsOutput
    var msg = "";
    state.extraLogs.forEach(function (l) {
      if (!msg) {
        msg = msg + "\n";
      }

      msg = msg + l;
    });
    return msg;
  }
}; // actions

var actions = {}; // mutations

var mutations = {
  updateMsgToUser: function updateMsgToUser(state, value) {
    if (value.hasOwnProperty("msg") && value.hasOwnProperty("type")) {
      // using unshift() instead of push(), add new element to the begining instead of the end
      state.msgToUser.unshift(value);
    }
  },
  updateExtraLogs: function updateExtraLogs(state, value) {
    if (typeof value === "undefined" || value.length == 0) {
      state.extraLogs = [];
    } else {
      state.extraLogs.push(value);
    }
  }
};
export default {
  namespaced: true,
  state: state,
  getters: getters,
  actions: actions,
  mutations: mutations
};